import React from 'react';
import { Chip } from '@mui/material';

const STATUS_COLORS: Record<string, { bg: string; color: string }> = {
  Active: { bg: '#ECFDF5', color: '#059669' },
  Approved: { bg: '#ECFDF5', color: '#10B981' },
  Successful: { bg: '#ECFDF5', color: '#059669' },
  Completed: { bg: '#ECFDF5', color: '#10B981' },
  Resolved: { bg: '#ECFDF5', color: '#059669' },
  Published: { bg: '#ECFDF5', color: '#10B981' },
  Sent: { bg: '#ECFDF5', color: '#059669' },
  Pending: { bg: '#FFFBEB', color: '#F59E0B' },
  'Under Review': { bg: '#FFFBEB', color: '#F59E0B' },
  Assigned: { bg: '#EFF6FF', color: '#2563EB' },
  Accepted: { bg: '#EFF6FF', color: '#1E3A8A' },
  'In Progress': { bg: '#EFF6FF', color: '#2563EB' },
  Open: { bg: '#EFF6FF', color: '#1E3A8A' },
  Suspended: { bg: '#FFF7ED', color: '#EA580C' },
  Inactive: { bg: '#F1F5F9', color: '#64748B' },
  Deactivated: { bg: '#F1F5F9', color: '#64748B' },
  Draft: { bg: '#FFFBEB', color: '#F59E0B' },
  Unpublished: { bg: '#F1F5F9', color: '#64748B' },
  Hidden: { bg: '#F1F5F9', color: '#64748B' },
  Rejected: { bg: '#FEF2F2', color: '#EF4444' },
  Failed: { bg: '#FEF2F2', color: '#EF4444' },
  Cancelled: { bg: '#FEF2F2', color: '#EF4444' },
  Closed: { bg: '#F1F5F9', color: '#475569' },
  Refunded: { bg: '#F5F3FF', color: '#7C3AED' },
};

interface StatusBadgeProps {
  status: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const palette = STATUS_COLORS[status] || { bg: '#F1F5F9', color: '#64748B' };
  return (
    <Chip
      label={status}
      size="small"
      sx={{
        backgroundColor: palette.bg,
        color: palette.color,
        fontWeight: 600,
        height: 24,
        fontSize: '0.75rem',
      }}
    />
  );
};

export default StatusBadge;
